<div *ngIf="aceessMenuByRoute?.bViewAccess">
  <div class="px-3">
    <div class="breadcrumb mb-0">
      <app-ng7-dynamic-breadcrumb [bgColor]="breadcrumbConfig['bgColor']" [fontSize]="breadcrumbConfig['fontSize']"
        [fontColor]="breadcrumbConfig['fontColor']" [lastLinkColor]="breadcrumbConfig['lastLinkColor']"
        [symbol]="breadcrumbConfig['symbol']"></app-ng7-dynamic-breadcrumb>
    </div>
  </div>

  <div class="main-container pms-logs-container">
    <div class="users-dashboard">
      <h1 class="main-title mb-4">PMS Logs</h1>
      <h2 class="card-title mb-3">User Activity</h2>

      <div class="pms-progressbar">
        <mat-progress-bar mode="determinate" value={{progressValue}} class="progressBar"></mat-progress-bar>
        <div class="pms-user-count">
          <div class="pms-active-user">
            <label>Active User</label>
            <span>{{activeUserCount}}</span>
          </div>
          <div class="pms-total-user">
            <label>Total User</label>
            <span>{{totalUserCount}}</span>
          </div>
        </div>
      </div>

      <div class="main-client-list">
        <div class="create-menu align-items-end">
          <div class="table-menu">
            <div class="filter-table">
              <mat-icon>search</mat-icon>
              <mat-form-field appearance="fill">
                <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
              </mat-form-field>
            </div>

            <div class="primary-button ms-4">
              <button (click)="sendMail()" mat-flat-button>Send Mail</button>
            </div>
          </div>

          <form [formGroup]="PmsDateForm" name="PmsDateForm">
            <div class="pms-datepicker-wrapper">
              <button type="button" (click)="prevPmsDate()" class="pms-datepicker-previous">
                Previous Day
              </button>

              <mat-form-field appearance="outline" class="pms-datepicker">
                <input matInput [matDatepicker]="picker" readonly placeholder="Date Picker" [max]="maxDateForRange"
                  formControlName="dtPmsDate" [(ngModel)]="selectedDate" (dateChange)="getDate(selectedDate)">
                <mat-datepicker #picker></mat-datepicker>
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <span matDatepickerToggleIcon class="pms-display-date">{{pmsDate}}</span>
                </mat-datepicker-toggle>
              </mat-form-field>

              <button type="button" (click)="nextPmsDate()" class="pms-datepicker-next"
                [ngClass]="{'pms-datepicker-disable': (selectedDate >= maxDateForRange || pmsDate == maxDateForRangeConverted)}">
                Next Day
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="main-users-table">
        <div class="users-table mt-4">
          <perfect-scrollbar [config]="config">
            <table mat-table [dataSource]="dataSource" matSort>
              <!-- <ng-container matColumnDef="checkbox">
                <th mat-header-cell *matHeaderCellDef class="separate-menu"> Select (to send mail) </th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox [checked]="element.checkbox" class="pms-checkbox" value={{element.userEmail}}
                    (change)="sendMailValue($event.source)" [disabled]="element.value!= 'null'"></mat-checkbox>
                </td>
              </ng-container> -->

              <ng-container matColumnDef="logsFilled">
                <th mat-header-cell *matHeaderCellDef> Logs Filled </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.value == 'null'"> No </span>
                  <span *ngIf="element.value != 'null'"> Yes </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="userEmail">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.userEmail}} </td>
              </ng-container>

              <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.userName == 'null' || element.userName == 'null null'; else NameElse"> - </span>
                  <ng-template #NameElse> {{element.userName}} </ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Time </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.value == 'null'"> - </span>
                  <span *ngIf="element.value != 'null'"> {{element.value}} Hrs </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell text-start text-xl-center pms-no-data" colspan="25">No data found</td>
              </tr>
            </table>
          </perfect-scrollbar>
        </div>

        <div class="ngb-pagination select-height">
          <select class="custom-select select-height" [(ngModel)]="rows" (ngModelChange)="UserCount();DailyLog();">
            <option [ngValue]="5">5</option>
            <option [ngValue]="10">10</option>
            <option [ngValue]="25">25</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
          <ngb-pagination #paginator id="paginator" [collectionSize]="totalUserCount" [pageSize]="rows" [maxSize]="2"
            [rotate]="true" [(page)]="page" [boundaryLinks]="true" (pageChange)="getUsersData($event)"
            class="d-flex justify-content-end pagination-rounded-flat pagination-success custom-pagination ms-4 ">
            <ng-template ngbPaginationPrevious>
              <mat-icon>chevron_left</mat-icon>
            </ng-template>
            <ng-template ngbPaginationNext>
              <mat-icon>chevron_right</mat-icon>
            </ng-template>
            <ng-template ngbPaginationFirst>
              <mat-icon>first_page</mat-icon>
            </ng-template>
            <ng-template ngbPaginationLast>
              <mat-icon>last_page</mat-icon>
            </ng-template>
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="aceessMenuByRoute?.bViewAccess == false">
  <div class="d-flex flex-column justify-content-center align-items-center text-center">
    <img class="mt-4 access-denied-image" src="./assets/images/access-denied.png" alt="">
    <p class="access-denied-paragraph">We are sorry, but you do not have access to this page or resource.</p>
    <div class="submit-btn mt-4">
      <button mat-button class="create-btn" routerLink="/dashboard">
        <mat-icon style="font-size:21px;padding-right:30px">arrow_back</mat-icon>
        Back to Dashboard
      </button>
    </div>
  </div>
</div>